import React from "react";
import { Package, ShoppingCart, BarChart3, Users, Smartphone, Cloud } from "lucide-react";
import { featuresData } from "../data/mock";

const iconMap = {
  Package,
  ShoppingCart,
  BarChart3,
  Users,
  Smartphone,
  Cloud
};

const Features = () => {
  return (
    <section id="caracteristicas" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Características Principales
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Todo lo que necesitas en <span className="text-blue-600">una sola plataforma</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            SAIP integra todas las herramientas esenciales para la gestión empresarial moderna, 
            diseñadas para maximizar tu productividad y rentabilidad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuresData.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group p-8 bg-white rounded-2xl border border-gray-100 hover:border-blue-200 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                style={{animationDelay: `${index * 100}ms`}}
              >
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                    <IconComponent size={32} />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
                  {feature.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
                
                <div className="mt-6">
                  <div className="w-12 h-1 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full group-hover:w-20 transition-all duration-300"></div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 lg:p-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
              ¿Necesitas una funcionalidad específica?
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              Nuestro equipo puede desarrollar módulos personalizados adaptados a las necesidades únicas de tu negocio.
            </p>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors">
              Consultar Personalización
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;